{
  "greeting": {
    "morning": "Bonjour, {{name}}",
    "afternoon": "Bon après-midi, {{name}}",
    "evening": "Bonsoir, {{name}}"
  },
  "quickActions": {
    "title": "Que voulez-vous faire ?"
  },
  "setup": {
    "title": "Configurez votre entreprise",
    "progress": "{{done}} étapes sur {{total}} terminées",
    "complete": "Prêt",
    "steps": {
      "identity": {
        "title": "Identité et identifiants légaux",
        "text": "Raison sociale, matricule fiscal et numéro du registre de commerce."
      },
      "regional": {
        "title": "Paramètres régionaux",
        "text": "Langue par défaut, fuseau horaire, formats des dates et des nombres."
      },
      "units": {
        "title": "Unités de mesure",
        "text": "Pièce, kilogramme, mètre... avec leurs décimales."
      },
      "categories": {
        "title": "Catégories de produits",
        "text": "Une arborescence simple pour organiser le catalogue : Électricité > Éclairage."
      },
      "team": {
        "title": "Votre équipe",
        "text": "Créez les utilisateurs, donnez-leur un rôle et leurs emplacements."
      },
      "locations": {
        "title": "Emplacements",
        "text": "Vos entrepôts et magasins, avec leurs zones et étagères."
      },
      "products": {
        "title": "Produits",
        "text": "Ajoutez-les un par un ou importez votre catalogue depuis Excel."
      }
    }
  },
  "activity": {
    "title": "Activité récente",
    "subtitle": "Chaque action est enregistrée et ne peut jamais être modifiée.",
    "empty": "Rien d'enregistré pour l'instant."
  },
  "waiting": {
    "approvals_one": "{{count}} correction attend votre accord",
    "approvals_many": "{{count}} corrections attendent votre accord",
    "approvals_other": "{{count}} corrections attendent votre accord",
    "approvalsText": "Elles dépassent le seuil de validation. Rien n'a encore changé dans le stock.",
    "drafts_one": "Vous avez {{count}} brouillon non terminé",
    "drafts_many": "Vous avez {{count}} brouillons non terminés",
    "drafts_other": "Vous avez {{count}} brouillons non terminés",
    "draftsText": "Validez-les ou abandonnez-les pour garder un stock juste.",
    "toReceive_one": "{{count}} transfert à recevoir",
    "toReceive_many": "{{count}} transferts à recevoir",
    "toReceive_other": "{{count}} transferts à recevoir",
    "toReceiveText": "En route vers vos emplacements : confirmez ce qui est arrivé.",
    "toReceiveLate_one": "{{count}} est en retard.",
    "toReceiveLate_many": "{{count}} sont en retard.",
    "toReceiveLate_other": "{{count}} sont en retard.",
    "countsToReview_one": "{{count}} inventaire à vérifier",
    "countsToReview_many": "{{count}} inventaires à vérifier",
    "countsToReview_other": "{{count}} inventaires à vérifier",
    "countsToReviewText": "Vérifiez les écarts, puis validez pour corriger le stock.",
    "countsInProgress_one": "{{count}} inventaire en cours",
    "countsInProgress_many": "{{count}} inventaires en cours",
    "countsInProgress_other": "{{count}} inventaires en cours",
    "countsInProgressText": "Leurs produits sont gelés jusqu'à leur validation ou leur annulation."
  },
  "openReports": "Ouvrir les rapports",
  "kpi": {
    "title": "Votre stock aujourd'hui",
    "updated": "Mis à jour à {{time}} · cliquez sur une carte pour voir la liste",
    "labels": {
      "value": "Valeur totale du stock",
      "products": "Produits actifs",
      "low": "Stock bas",
      "out": "En rupture",
      "negative": "Stock négatif",
      "transit": "Transferts en transit",
      "today": "Mouvements du jour",
      "dead": "Stock dormant"
    },
    "badges": {
      "low": "Bas",
      "out": "Rupture",
      "negative": "Négatif"
    },
    "items_one": "article",
    "items_other": "articles",
    "productsUnit_one": "produit",
    "productsUnit_other": "produits",
    "transfersUnit_one": "transfert",
    "transfersUnit_other": "transferts",
    "operationsUnit_one": "opération",
    "operationsUnit_other": "opérations",
    "valueNote": "Tous les emplacements, au coût moyen pondéré",
    "valueNoteSite": "Cet emplacement, au coût moyen pondéré",
    "addedThisMonth_one": "{{count}} ajouté ce mois-ci",
    "addedThisMonth_other": "{{count}} ajoutés ce mois-ci",
    "lowNote": "Au minimum ou en dessous",
    "outNote": "Plus rien nulle part",
    "negativeNote": "À compter ou à corriger",
    "transitNone": "Rien en route",
    "transitToday": "Le plus ancien est parti aujourd'hui",
    "transitOldest_one": "Le plus ancien est parti il y a {{count}} jour",
    "transitOldest_other": "Le plus ancien est parti il y a {{count}} jours",
    "todayNote_one": "{{in}} entrées · {{out}} sorties · {{count}} ajustement",
    "todayNote_other": "{{in}} entrées · {{out}} sorties · {{count}} ajustements",
    "deadNote_one": "Aucun mouvement depuis {{count}} jour ou plus",
    "deadNote_other": "Aucun mouvement depuis {{count}} jours ou plus",
    "outNoteSite": "Plus rien dans cet emplacement"
  },
  "attention": {
    "title": "À traiter",
    "seeAll": "Voir toutes les alertes",
    "empty": "Rien à traiter",
    "emptyText": "Aucune alerte ouverte pour le moment."
  },
  "value": {
    "title": "Où est la valeur de mon stock ?",
    "bySite": "Par emplacement",
    "byCategory": "Par catégorie",
    "total": "TND au total",
    "noCategory": "Sans catégorie",
    "empty": "Pas encore de stock.",
    "note": "Les valeurs utilisent le coût moyen pondéré de chaque produit. Sans la permission « voir les coûts », on ne voit que les quantités."
  },
  "inOut": {
    "title": "Entrées et sorties de stock",
    "unitValue": "14 derniers jours · valeur en TND",
    "unitLines": "14 derniers jours · lignes de mouvement",
    "in": "Entrées",
    "out": "Sorties",
    "day": "Jour",
    "table": "Voir les chiffres en tableau",
    "empty": "Aucune entrée ni sortie de stock ces 14 derniers jours."
  },
  "sales": {
    "title": "Les ventes aujourd'hui",
    "open": "Rapports de ventes",
    "labels": {
      "today": "Vendu aujourd'hui (net)",
      "waiting": "Commandes à remettre",
      "courier": "Contre-remboursements non versés"
    },
    "orders_one": "{{count}} vente",
    "orders_many": "{{count}} ventes",
    "orders_other": "{{count}} ventes",
    "returns": "{{amount}} TND rendus",
    "vsYesterday": "{{value}} % par rapport à hier",
    "ordersUnit_one": "commande",
    "ordersUnit_many": "commandes",
    "ordersUnit_other": "commandes",
    "waitingNone": "Rien en attente de départ",
    "oldest_one": "La plus ancienne : {{count}} jour",
    "oldest_many": "La plus ancienne : {{count}} jours",
    "oldest_other": "La plus ancienne : {{count}} jours",
    "courierNone": "Toutes les livraisons sont versées",
    "deliveries_one": "{{count}} livraison non versée",
    "deliveries_many": "{{count}} livraisons non versées",
    "deliveries_other": "{{count}} livraisons non versées",
    "late_one": "{{count}} en retard",
    "late_many": "{{count}} en retard",
    "late_other": "{{count}} en retard"
  }
}
